import moment from 'moment'
export default {
  methods: {
    isSupportLanguage: function(message, ispremium) {
      if (ispremium) return true
      else {
        return (
          message.search(
            /[^ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s]/gim
          ) === -1
        )
      }
    },
    isURL: function(str) {
      var pattern = new RegExp(
        /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) // fragment locator
      return pattern.test(str)
    },
    isJsonParseable: function(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    isNumber: function(str) {
      try {
        parseFloat(str)
      } catch (e) {
        return false
      }
      return true
    },
    exportCsv: function(csvContent, name) {
      var csvData = new Blob([csvContent], { type: 'text/csv' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', name + '_' + moment().format('YYYY_MM_DD') + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    setLang: function(lang) {
      this.$store.dispatch('setLang', lang)
    },
    convertCondition(val) {
      if (val != null) {
        var conditions = val.split('&&')
        if (conditions.length > 0) {
          var cons = []
          var convertString = function(replaceTo, val, toBe) {
            return val.split(replaceTo).join(toBe)
          }

          conditions.forEach((condition, index) => {
            var con = condition
            con = convertString('==', con, ' EQUAL TO ')
            con = convertString('!=', con, ' NOT EQUAL TO ')
            con = convertString('>=', con, ' GREATER THAN OR EQUAL TO ')
            con = convertString('<=', con, ' LESS THAN OR EQUAL TO ')
            con = convertString('>', con, ' GREATER THAN ')
            con = convertString('<', con, ' LESS THAN ')
            cons.push(con)
          })

          return cons.join(' AND ')
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mainMixin.js